export default class Attachment {
  /**
   * Create new attachment and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }
}
